module.exports = __webpack_public_path__ + "img/helmet.87357455.svg";